import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";

type FolderItemProps = {
  active: boolean;
  onClick: () => void;
  icon: IconDefinition;
  title: string;
};

export default function TableServiceFolderItem(props: FolderItemProps) {
  const [onHover, setOnHover] = useState<boolean>(false);
  const [scrollText, setScrollText] = useState<boolean>(false);

  const pRef = useRef<HTMLParagraphElement>(null);
  const liRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    if (onHover && pRef?.current && pRef?.current?.offsetWidth < pRef?.current?.scrollWidth) {
      setScrollText(true);
    } else {
      setScrollText(false);
    }
  }, [onHover]);

  return (
    <li
      className={`table-service-folders-menu-option ${
        props.active ? "table-service-folders-menu-option-selected" : ""
      }`}
      onClick={props.onClick}
      onMouseEnter={() => setOnHover(true)}
      onMouseLeave={() => setOnHover(false)}
      title={props.title}
      aria-label={props.title}
      ref={liRef}
    >
      <span>
        <FontAwesomeIcon
          icon={props.icon}
          fixedWidth
          style={{ backgroundColor: props.active || onHover ? "#F9FAFB" : "inherit" }}
        />
        <p ref={pRef} className={scrollText ? "scroll-text" : ""}>
          {props.title}
        </p>
      </span>
    </li>
  );
}
